// extracted by mini-css-extract-plugin
export default {"container":"BtV1c","item":"qlx0S","icon":"gwZRt","modal-title":"Yl1Ij","title":"pMIM0","text":"ppXuG","is-disabled":"qAIOz"};